export class Validations {
    static objectIsEmpty = (value: Object) : boolean => {
      if(value === null || value ===  undefined){
        return true;
      }else{
        return Object.keys(value).length === 0 && value.constructor === Object;
      }
    }
}